import type { DeepString } from "@/lib/i18n";

/**
 * WShopNewProducts - stringi chrome okna (naglowek + CTA).
 * Etykiety kafelka (badge, status, cena, "do koszyka") pochodza z
 * `<ProductCard />` (wspoldzielony i18n `components/ui/ProductCard`).
 */
export const pl = {
  title: "Nowości",
  showAll: "Zobacz wszystkie",
  noProducts: "Brak nowości.",
} as const;

export type WShopNewProductsTranslations = DeepString<typeof pl>;
